import React from 'react';
import Logo from './logo';



function Header() {
    return ( 
        <div>
            <h2>I am header component!</h2>
            <Logo company="red"></Logo>
            <Logo company="yellow"></Logo>
            <Logo company="blue"></Logo>
            <Logo company="purple"></Logo>
        </div>
     );
}

export default Header;